import { Container, Col, Row } from "reactstrap";
import { HoursDiv, CaterDiv, ImgContainer, Img, CompanyDiv } from './FooterStyle';

export default function Footer() {
    return(
        <div style={{textAlign: 'center'}}>
            <HoursDiv>
                <h3>Hours of Operation</h3>
                <div>Mon – Fri 8 am-7pm <span>|</span> Sat 9am – 4pm <span>|</span> Sun Closed</div>
            </HoursDiv>
            <CaterDiv>
                <Container>
                    <Row>
                        <Col md="1"><Img src="/images/flecha.png" loading="lazy" alt="arrow"></Img></Col>
                        <ImgContainer md="10"><img src="/images/footerText.png" loading="lazy" alt="catering text info"></img></ImgContainer>
                        <Col md="1"><Img src="/images/bag.png" loading="lazy" alt="bag"></Img></Col>
                    </Row>
                </Container>
            </CaterDiv>
            <CompanyDiv>Design by <a href="https://www.vmsteam.com">V&M Website Solutions</a></CompanyDiv>
        </div>
    )
}